import { Row, StaleLoader } from 'components';
import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useStoreActions, useStoreState } from 'state';

const Auth: FC = ({ children }) => {
  const history = useHistory();
  const { isAuthLoading, userId, entityId } = useStoreState(
    ({ UserState }) => UserState
  );
  const { getFeatureFlags } = useStoreActions(
    ({ FeatureFlagsState }) => FeatureFlagsState
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isAuthLoading && (userId || entityId)) {
      const handleAuth = async () => {
        await getFeatureFlags();

        setIsLoading(false);
      };

      handleAuth();
    }

    if (!isAuthLoading && !userId && !entityId) {
      history.push('/login', {
        from: {
          pathname: history.location.pathname,
        },
      });
    }
  }, [entityId, getFeatureFlags, history, isAuthLoading, userId]);

  return (
    <>
      {isAuthLoading || isLoading ? (
        <Row justifyContent="center" alignSelf="stretch" flex={1}>
          <StaleLoader size="large" />
        </Row>
      ) : (
        children
      )}
    </>
  );
};

export default Auth;
